module.exports = __webpack_public_path__ + "img/step1.17db8c41.png";